import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/AppShell.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'dashboard', component: () => import('@/views/DashboardView.vue') },
      { path: 'products', name: 'products', component: () => import('@/views/ProductsView.vue') },
      { path: 'products/:id', name: 'product', component: () => import('@/views/ProductDetailView.vue') },
      { path: 'structure', name: 'structure', component: () => import('@/views/StructureView.vue') },
      { path: 'structure/collections/:id', name: 'collection', component: () => import('@/views/CollectionDetailView.vue') },
      { path: 'audit', name: 'audit', component: () => import('@/views/AuditView.vue') },
      { path: 'proposals', name: 'proposals', component: () => import('@/views/ProposalsView.vue') },
      { path: 'releases', name: 'releases', component: () => import('@/views/ReleasesView.vue') },
      { path: 'releases/:id', name: 'release', component: () => import('@/views/ReleaseDetailView.vue') },
      { path: 'bookkeeping', name: 'bookkeeping', component: () => import('@/views/BookkeepingView.vue') },
      { path: 'suppliers/:supplier?', name: 'supplier', component: () => import('@/views/SupplierView.vue') },
      { path: 'matching', name: 'matching', component: () => import('@/views/MatchingView.vue') },
      { path: 'suppliers/:supplier/products/:id', name: 'supplier-product', component: () => import('@/views/SupplierProductView.vue') },
      { path: 'search', name: 'search', component: () => import('@/views/SearchView.vue') },
      { path: 'articles', name: 'articles', component: () => import('@/views/ArticlesView.vue') },
      { path: 'articles/:id', name: 'article', component: () => import('@/views/ArticleEditorView.vue') },
      { path: 'sync', name: 'sync', component: () => import('@/views/SyncView.vue') },
      {
        path: 'members',
        name: 'members',
        component: () => import('@/views/MembersView.vue'),
        meta: { requiresAdmin: true },
      },
      { path: 'settings', name: 'settings', component: () => import('@/views/SettingsView.vue') },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { public: true },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: (_to, _from, saved) => saved ?? { top: 0 },
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  // One session probe on first navigation; afterwards the store answers from memory.
  await auth.restore()

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: to.fullPath === '/' ? {} : { redirect: to.fullPath } }
  }

  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return { name: 'dashboard' }
  }

  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'dashboard' }
  }

  return true
})
